import { render, staticRenderFns } from "./sit-select.vue?vue&type=template&id=e66a23d8&scoped=true&"
import script from "./sit-select.vue?vue&type=script&lang=js&"
export * from "./sit-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66a23d8",
  null
  
)

export default component.exports